export default __webpack_public_path__ + "static/media/assault-rifles.73fc6d58.svg";